import styles from './Camouflages.scss';
import classNames from 'classnames';
import { items } from '@wg/wows-entities/const';
import BundleType from '../BundleType/BundleType';

interface ICamouflagesPerks {
    item: IBundleEntity;
    className?: string;
    isShort?: boolean;
}

export const isPermanentCamouflage = (type: string) => {
    return [items.PERMOFLAGES, items.SKIN, items.STYLE, items.MSKIN].includes(type as items);
};

export const isCamouflage = (type: string) => {
    return [items.CAMOUFLAGE].includes(type as items);
};

const CamouflagesPerks = (props: ICamouflagesPerks): any => {
    const item = props.item;

    return (
        <div className={styles.wrapper}>
            {item.customisation && (
                <div className={classNames(styles.permanent, styles.camouflage, props.className)}>
                    <BundleType item={item} />
                </div>
            )}
        </div>
    );
};

export default CamouflagesPerks;
